export const chatroomInfo = {
  test: {
    // room_id: '3713261169623416832',
    // channel_id: '3713261169866170370',
    invite_code: 'if4zweqs',
  },
  online: {
    // room_id: '3713772842432856064',
    // channel_id: '3713774676165541888',
    invite_code: 'ieddv0om',
  },
};
